import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ChantUserModel, ChantUserTextField } from '@core/models/cu/chant-user-model';
import { GroupeChantantService } from '@core/service/ce/groupChantant/groupe-chantant.service';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { ImportALlModule } from '@shared/imports';

@Component({
  selector: 'app-groupe-chantant-dropdown',
  standalone: true,
  imports: [
    ImportALlModule,
  ],
  templateUrl: './groupe-chantant-dropdown.component.html',
  styleUrl: './groupe-chantant-dropdown.component.scss'
})
export class GroupeChantantDropdownComponent {

  textField = ChantUserTextField;
  @Input() objChant: ChantUserModel = new ChantUserModel();
  @Input() control!: FormControl;
  @Output() onChangeGroupeEventEmiter = new EventEmitter<any>();

  constructor(public groupeChantantService: GroupeChantantService ){  }

  onChangeGroupe() {
    this.onChangeGroupeEventEmiter.emit()
  }

}
